import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardAdmin } from 'lib-trend-core';
import { CampaignFormComponent } from './campaign-form/campaign-form.component';
import { CampaignListComponent } from './campaign-list/campaign-list.component';
import { CampaignTemplatesComponent } from './campaign-templates/campaign-templates.component';
import { CampaignMessageComponent } from './campaign-message/campaign-message.component';

const routes: Routes = [
  { path: '', component: CampaignListComponent, },
  { path: 'new', component: CampaignFormComponent, },
  { path: ':id/edit', component: CampaignFormComponent, },
  { path: ':id/messages', component: CampaignMessageComponent },
  { path: 'list-template', component: CampaignTemplatesComponent, canActivate: [AuthGuardAdmin] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CampaignRoutingModule { }
